// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"270":"b7915132","499":"9c529136"}[chunkId] + ".css";
};